import React, { useEffect, useState } from 'react'
import { Row, Col, Skeleton, DatePicker, Select } from 'antd'
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/ru_RU'

import Table from './Table'
import { getCashRegisterStat } from '../../../api/different'

import './index.less'

moment.locale('ru')

const { RangePicker } = DatePicker
const { Option } = Select

const CashRegisterStat = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [sellerSearchValue, setSellerSearchValue] = useState('')
  const [selectedSellerId, setSelectedSellerId] = useState(undefined)
  const [dateRange, setDateRange] = useState([
    moment().add(-1, 'M'),
    moment(),
  ])

  useEffect(() => {
    if (dateRange.length === 2) {
      setLoading(true)

      const payload = {
        dateBegin: dateRange[0].format('YYYY-MM-DD'),
        dateEnd: dateRange[1].format('YYYY-MM-DD'),
      }

      getCashRegisterStat(payload)
        .then((res) => {
          const { result = [] } = res

          setData(result)
          setSellerSearchValue('')
          setSelectedSellerId(undefined)
          setLoading(false)
        })
        .catch((res) => {
          console.log(res)
          console.log('Error')
          setData([])
          setLoading(false)
        })
    }
  }, [dateRange])

  const onChangeRange = (e) => {
    setDateRange(e || [])
  }

  const sellerOptions = data
    .reduce((acc, item) => {
      const sellerId = `${item.idnum || ''}`.trim()

      if (!sellerId || acc.some(option => option.idnum === sellerId)) {
        return acc
      }

      acc.push({
        idnum: sellerId,
        seller_name: item.seller_name,
      })

      return acc
    }, [])
    .sort((a, b) => parseInt(a.idnum || 0) - parseInt(b.idnum || 0))

  const displayedSellerOptions = sellerSearchValue
    ? sellerOptions.filter(item => item.idnum.indexOf(sellerSearchValue.trim()) !== -1)
    : sellerOptions

  const filteredData = selectedSellerId
    ? data.filter(item => `${item.idnum}` === `${selectedSellerId}`)
    : data

  const cashRegisterCount = filteredData
    .reduce((acc, item) => {
      const cashRegisterId = `${item.s_kkm || ''}`.trim()

      if (!cashRegisterId || acc.includes(cashRegisterId)) {
        return acc
      }

      return [...acc, cashRegisterId]
    }, []).length

  return (
    <div>
      {!loading ?
        <React.Fragment>
          <Row type='flex' justify='start' gutter={[16, 24]}>
            <Col>
              <RangePicker
                locale={locale}
                defaultValue={dateRange}
                onChange={onChangeRange}
              />
            </Col>
            <Col>
              <Select
                showSearch
                allowClear
                value={selectedSellerId}
                placeholder='Фильтр по Seller ID'
                style={{ minWidth: 240 }}
                filterOption={false}
                onSearch={value => setSellerSearchValue(value || '')}
                onChange={(value) => {
                  setSelectedSellerId(value)
                  setSellerSearchValue(value || '')
                }}
                onClear={() => {
                  setSelectedSellerId(undefined)
                  setSellerSearchValue('')
                }}
                notFoundContent='Seller ID не найден'
              >
                {displayedSellerOptions.map(item => (
                  <Option key={item.idnum} value={item.idnum}>
                    {item.idnum}{item.seller_name ? ` — ${item.seller_name}` : ''}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row type='flex' justify='start' gutter={[16, 24]}>
            <Col>
              <Table
                loading={loading}
                dataSource={filteredData}
                scroll={{ x: '100%' }}
                size='middle'
              />
            </Col>
          </Row>
        </React.Fragment>
        :
        <Skeleton active />}
    </div>
  )
}

export default CashRegisterStat


// WEBPACK FOOTER //
// src/containers/Dashboard/CashRegisterStat/index.jsx